'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoChevronDown = function IoChevronDown(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 23.3l13.6-13.1c0.3-0.3 0.9-0.3 1.2 0l2.5 2.4c0.3 0.3 0.3 0.9 0 1.2l-16.7 16c-0.1 0.1-0.4 0.2-0.6 0.2s-0.5-0.1-0.6-0.2l-16.7-16c-0.3-0.3-0.3-0.9 0-1.2l2.5-2.4c0.3-0.3 0.9-0.3 1.2 0z' })
        )
    );
};

exports.default = IoChevronDown;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/chevron-down.js
// module id = 2015
// module chunks = 0